const extraAbbrevs = {
  Wide: "W",
  "No Ball": "NB",
  Bye: "B",
  "Leg Bye": "LB",
};

export default extraAbbrevs;
